var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "locaiotn",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.991,
    height: 22.464,
    viewBox: "0 0 15.991 22.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 15.991,
    height: 22.464,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M11.865,0c-2.309,0-4.95,3.587-4.95,8,0,5.7,4.636,13.992,4.8,14.342.038.08.092.126.148.126a.38.38,0,0,0,.283-.126C12.463,21.987,19.86,13.692,19.86,8a8,8,0,0,0-8-8m0,12.184A4.188,4.188,0,1,1,16.053,8a4.188,4.188,0,0,1-4.188,4.188",
    transform: "translate(-3.869)",
    fill: "#3e51a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M7.847,22.338c-.165-.351-4.8-8.646-4.8-14.342,0-4.409,2.641-8,4.95-8A8,8,0,0,0,0,8c0,5.7,7.4,13.991,7.712,14.342A.381.381,0,0,0,8,22.464c-.057,0-.111-.046-.148-.126",
    fill: "#d51a66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.814c96d46ab4e64f415fe0e8d37cc09a.svg";
export { ForwardRef as ReactComponent };